import { GenericService } from '../GenericService'

class CompanyUserService extends GenericService {
    constructor() {
        super('/api/admin/companyUsers')
    }

    getSingleRecord = (id) =>
        this.get('/api/admin/companyUsers/getSingle/' + id)
    changePassword = (data) =>
        this.post('/api/admin/companyUsers/changePassword', data)
    multipleDelete = (data) =>
        this.post('/api/admin/companyUsers/multipleDelete', data)
}

export default new CompanyUserService()
